import { useI18n } from "@/i18n";
import { Globe2 } from "lucide-react";

export default function LanguageSwitcher({ compact = false, testid = "lang-switcher" }) {
  const { lang, setLang, languages } = useI18n();
  return (
    <label className={`inline-flex items-center gap-2 ${compact ? "text-xs" : "text-sm"}`}>
      <Globe2 size={compact ? 12 : 14} className="text-[color:var(--mano-ink-soft)]" />
      <select
        data-testid={testid}
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className={`bg-transparent border border-[color:var(--mano-border)] rounded-full ${compact ? "px-2 py-1" : "px-3 py-1.5"} focus:outline-none font-medium`}
      >
        {languages.map((l) => (
          <option key={l.code} value={l.code}>
            {l.native}
          </option>
        ))}
      </select>
    </label>
  );
}
